import styled, { css } from 'styled-components';

import { T5D, T4D } from '../Text';

import { media } from '../../styles/constants';
import { onlyHorizontalPaddingStyle } from '../../styles/padding';

const WorkdetailSection = styled.div`
  max-width: 97rem;
  margin-bottom: 2rem;

  ${props =>
    !props.noPadding &&
    css`
      ${onlyHorizontalPaddingStyle}
    `}

  @media (min-width: ${media.tabletPortrait}) {
    margin-bottom: 3rem;
  }

  @media (min-width: ${media.desktop}) {
    margin-bottom: 5rem;
  }

  ${T5D}, ${T4D} {
    margin-bottom: 3rem;
  }
`;

export default WorkdetailSection;
